import { IconButton, Tooltip } from "@material-ui/core";
import React from "react";
import "./LinkIcons.css";

function LinkIcons({ Icon, title, color, link }) {
  return (
    <div className="linkIcons" onClick={() => window.open(link)}>
      <Tooltip title={title} placement="top">
        <IconButton style={{ color: `${color}` }}>
          <Icon fontSize="large" />
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default LinkIcons;
